App.prototype.addProductToCart = function (productUid, quantity, queryStringAppend) {
    var data = {
        product_unique_id: productUid,
        quantity: quantity,
    };
    $.ajax({
        type: 'POST',
        url: App.prototype.apiAddress + 'basket' + queryStringAppend,
        dataType: "json",
        data: data,
        success: function (response) {
            App.prototype.notificationSuccess(translates.product_added_to_cart);
            App.prototype.buildCart(response);

            if($('.modal').length){

                $('.modal').modal('hide');

            }

            if(typeof fbq !== 'undefined'){
                fbq(response.pixel.eventType, response.pixel.eventName, response.pixel.customData, response.pixel.eventData);
            }

        },
        error: function (response){

            const error = response.responseJSON && response.responseJSON.error ? response.responseJSON.error : translates.product_add_to_cart_error;

            if (error.indexOf("Teslimat") !== -1){

                $('.change-shop-area').trigger("click");

            }

            App.prototype.notificationError(error);

        }
    });
};
